/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseFormFieldDirective} from '../../base-form-field.directive';
import {ReactiveFormsModule} from '@angular/forms';
import {IxModule} from '@siemens/ix-angular';
import {TranslateModule} from '@ngx-translate/core';
import {FieldLabelComponent} from '../field-label/field-label.component';

@Component({
  selector: 'app-select-input',
  imports: [
    CommonModule,
    IxModule,
    TranslateModule,
    ReactiveFormsModule,
    FieldLabelComponent,
  ],
  templateUrl: './enum-input.component.html',
  styleUrl: '../input-components.scss',
})
export class EnumInputComponent extends BaseFormFieldDirective {
  constructor() {
    super();
  }
}
